<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42 7H6a2 2 0 00-2 2v27a2 2 0 002 2h10v3h-4.5a1.5 1.5 0 000 3h25a1.5 1.5 0 000-3H32v-3h10a2 2 0 002-2V9a2 2 0 00-2-2zm-1 3v18H7V10zM30 35H7v-5h34v5zm0 6H18v-3h12z"/></svg>